module.exports = __webpack_public_path__ + "src/assets/img/door_left_color.2e8ca9b8.svg";